import { t } from 'i18next';
import { EventReasonsOptions } from 'queries/events/contract';
import { removeUnderline } from './utils';

export const statuses = [
  { value: 'OPEN', label: t('event_page:chart_status.status.OPEN') },
  { value: 'CLOSED', label: t('event_page:chart_status.status.CLOSED') },
];

export const buildWhyNotUsefulOptions = (data?: EventReasonsOptions, actualReason?: string) => {
  const options =
    data?.not_useful_reason && data?.not_useful_reason.length > 0
      ? data?.not_useful_reason
      : ['OTHER', 'PROCESS_CHANGE'];
  if (actualReason && !options.includes(actualReason)) {
    options.push(actualReason);
  }
  return options.map((reason) => ({
    value: reason,
    label: t(`event_page:chart_status.whyNotUseful.${reason}`, {
      defaultValue: removeUnderline(reason).replaceAll('.', ' ').toLowerCase(),
    }),
  }));
};
